var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"float":"right","padding-right":"calc(0.5%)"}},[_c('nav',[_c('ul',{staticClass:"pagination b-pagination pagination-sm",attrs:{"role":"menubar","aria-disabled":"false","aria-label":"Pagination"}},[(_vm.currentPage == 1)?[_vm._m(0)]:[_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('router-link',{staticClass:"page-link",attrs:{"to":'/productos/' +
                _vm.critFilter +
                '/1/' +
                _vm.cateFilter +
                '/' +
                _vm.subcateFilter +
                '/' +
                _vm.caliberFilter +
                '/' +
                _vm.brandFilter +
                (_vm.queryFilter == 0 ? '' : '/' + _vm.queryFilter) +
                '',"role":"menuitem","tabindex":"-1","aria-label":"Goto next page","target":"_self"}},[_c('span',{staticClass:"page-selector",attrs:{"aria-hidden":"true"}},[_vm._v("«")])])],1)],(_vm.currentPage > 1)?[_c('li',{staticClass:"page-item",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('router-link',{attrs:{"to":'/productos/' +
                _vm.critFilter +
                '/' +
                (_vm.currentPage - 1) +
                '/' +
                _vm.cateFilter +
                '/' +
                _vm.subcateFilter +
                '/' +
                _vm.caliberFilter +
                '/' +
                _vm.brandFilter +
                (_vm.queryFilter == 0 ? '' : '/' + _vm.queryFilter) +
                ''}},[_c('span',{staticClass:"page-link page-selector",attrs:{"aria-hidden":"true"}},[_vm._v("‹")])])],1)]:[_vm._m(1)],_vm._l((_vm.availablePages),function(page){return _c('li',{key:page,class:['page-item', page == _vm.currentPage ? 'active' : ''],attrs:{"role":"none presentation"}},[_c('router-link',{staticClass:"page-link page-selector",attrs:{"to":'/productos/' +
              _vm.critFilter +
              '/' +
              page +
              '/' +
              _vm.cateFilter +
              '/' +
              _vm.subcateFilter +
              '/' +
              _vm.caliberFilter +
              '/' +
              _vm.brandFilter +
              (_vm.queryFilter == 0 ? '' : '/' + _vm.queryFilter) +
              '',"role":"menuitemradio","tabindex":"-1","aria-label":"Goto page 2","aria-checked":"false","aria-posinset":"2","aria-setsize":"4","target":"_self"}},[_vm._v(_vm._s(page))])],1)}),(_vm.currentPage == _vm.finalPage)?[_vm._m(2)]:[_c('li',{staticClass:"page-item",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('router-link',{attrs:{"to":'/productos/' +
                _vm.critFilter +
                '/' +
                (parseInt(_vm.currentPage) + 1) +
                '/' +
                _vm.cateFilter +
                '/' +
                _vm.subcateFilter +
                '/' +
                _vm.caliberFilter +
                '/' +
                _vm.brandFilter +
                (_vm.queryFilter == 0 ? '' : '/' + _vm.queryFilter) +
                ''}},[_c('span',{staticClass:"page-link page-selector",attrs:{"aria-hidden":"true"}},[_vm._v("›")])])],1)],(_vm.currentPage == _vm.finalPage)?[_vm._m(3)]:[_c('li',{staticClass:"page-item",attrs:{"role":"none presentation"}},[_c('router-link',{staticClass:"page-link",attrs:{"to":'/productos/' +
                _vm.critFilter +
                '/' +
                _vm.finalPage +
                '/' +
                _vm.cateFilter +
                '/' +
                _vm.subcateFilter +
                '/' +
                _vm.caliberFilter +
                '/' +
                _vm.brandFilter +
                (_vm.queryFilter == 0 ? '' : '/' + _vm.queryFilter) +
                '',"role":"menuitem","tabindex":"-1","aria-label":"Goto next page","target":"_self"}},[_c('span',{staticClass:"page-selector",attrs:{"aria-hidden":"true"}},[_vm._v("»")])])],1)]],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation"}},[_c('a',{staticClass:"page-link",attrs:{"role":"menuitem","tabindex":"-1","aria-label":"Goto next page","target":"_self"}},[_c('span',{staticClass:"page-selector",attrs:{"aria-hidden":"true"}},[_vm._v("«")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation","aria-hidden":"true"}},[_c('span',{staticClass:"page-link page-selector"},[_vm._v("‹")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation"}},[_c('a',{staticClass:"page-link",attrs:{"role":"menuitem","tabindex":"-1","aria-label":"Goto next page","target":"_self"}},[_c('span',{staticClass:"page-selector",attrs:{"aria-hidden":"true"}},[_vm._v("›")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"page-item disabled",attrs:{"role":"none presentation"}},[_c('a',{staticClass:"page-link",attrs:{"role":"menuitem","tabindex":"-1","aria-label":"Goto next page","target":"_self"}},[_c('span',{staticClass:"page-selector",attrs:{"aria-hidden":"true"}},[_vm._v("»")])])])}]

export { render, staticRenderFns }